(() => {
  'use strict';
  document.querySelectorAll('[data-mc-gallery]').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-mc-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-mc-thumb]')];
    thumbnails.forEach(button => button.addEventListener('click', () => {
      slides.forEach(slide => { slide.hidden = slide.dataset.mcSlide !== button.dataset.mcThumb; });
      thumbnails.forEach(thumb => { thumb.setAttribute('aria-pressed', String(thumb === button)); });
    }));
  });
  const menuToggle = document.querySelector('.mc-menu-toggle');
  const navigation = document.querySelector('#mc-navigation');
  function closeMenu() {
    if (!menuToggle || !navigation) return;
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.setAttribute('aria-label', menuToggle.dataset.openLabel);
    navigation.classList.remove('is-open');
  }
  if (menuToggle && navigation) {
    menuToggle.addEventListener('click', () => {
      const expanded = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', String(expanded));
      menuToggle.setAttribute('aria-label', expanded ? menuToggle.dataset.closeLabel : menuToggle.dataset.openLabel);
      navigation.classList.toggle('is-open', expanded);
    });
    navigation.addEventListener('keydown', event => {
      if (event.key === 'Escape') { closeMenu(); menuToggle.focus(); }
    });
    navigation.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
  }
  const root = document.querySelector('[data-mc-catalogue]');
  if (root) {
    const grid = root.querySelector('[data-mc-grid]'), cards = [...grid.querySelectorAll('[data-mc-product]')];
    const shapes = [...root.querySelectorAll('[data-mc-shape]')];
    function apply() {
      const term = (new URLSearchParams(location.search).get('q') || '').trim().toLowerCase(), group = location.hash.slice(1), sorted = [...cards];
      const shape = shapes.find(r => r.checked)?.value.toLowerCase() || '';
      let count = 0;
      for (const card of sorted) {
        const tags = card.dataset.tags.toLowerCase();
        const match = !group || (group === 'new' ? tags.includes('new 2026') : group === 'sets' ? tags.includes('mug pair') || tags.includes('set of 4 mugs') : card.dataset.group === group);
        card.hidden = !(match && (!shape || tags.split('|').includes(shape)) && card.dataset.search.toLowerCase().includes(term));
        if (!card.hidden) count++;
        grid.append(card);
      }
      root.querySelector('[data-mc-empty]').hidden = count > 0;
      root.querySelector('[data-mc-results]').textContent = count;
    }
    function hash() { (shapes.find(r => r.value === new URLSearchParams(location.search).get('shape')) || shapes[0]).checked = true; apply(); }
    shapes.forEach(radio => radio.addEventListener('change', () => {
      const url = new URL(location.href);
      if (radio.value) url.searchParams.set('shape', radio.value); else url.searchParams.delete('shape');
      history.replaceState(null, '', url); apply();
    }));
    document.querySelectorAll('[data-mc-nav-shape], [data-mc-nav-group]').forEach(link => link.addEventListener('click', event => {
      const destination = new URL(link.href);
      if (destination.pathname !== location.pathname) return;
      event.preventDefault();
      const url = new URL(location.href);
      if (link.hasAttribute('data-mc-nav-shape')) {
        const shape = link.dataset.mcNavShape;
        if (shape) url.searchParams.set('shape', shape); else url.searchParams.delete('shape');
      } else url.hash = destination.hash;
      history.replaceState(null, '', url); hash(); closeMenu();
      root.querySelector('.mc-result-count').focus({preventScroll:true});
    }));
    root.querySelector('[data-mc-reset]').addEventListener('click', () => {
      shapes[0].checked = true;
      const url = new URL(location.href); url.hash = ''; url.searchParams.delete('q'); url.searchParams.delete('shape'); history.replaceState(null, '', url); apply();
    });
    window.addEventListener('hashchange', hash); window.addEventListener('popstate', hash); hash();
  }
  const messages = document.querySelector('[data-mc-messages]'), toast = document.querySelector('[data-mc-toast]');
  document.querySelector('[data-mc-dismiss]')?.addEventListener('click', () => { toast.hidden = true; });
  let queue = Promise.resolve();
  document.querySelectorAll('.mc-add-form').forEach(form => form.addEventListener('submit', event => {
    if (!messages || !toast || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const quantity = form.querySelector('[name="quantity"]');
    if (!Number.isSafeInteger(Number(quantity.value)) || Number(quantity.value) < (Number(quantity.min) || 3)) { quantity.focus(); return; }
    const payload = new FormData(form), button = form.querySelector('[type="submit"]'), original = button.textContent;
    form.dataset.busy = 'true'; button.disabled = true; button.textContent = messages.dataset.adding; form.setAttribute('aria-busy', 'true');
    queue = queue.then(async () => {
      let added = false;
      try {
        const response = await fetch(messages.dataset.addUrl + '.js', {method:'POST',body:payload,headers:{Accept:'application/json'},credentials:'same-origin'});
        const result = await response.json();
        if (!response.ok || result.status || !(result.id || result.items)) throw new Error(messages.dataset.error);
        added = true; toast.hidden = false; toast.querySelector('[data-mc-message]').textContent = messages.dataset.added;
        const cartResponse = await fetch(messages.dataset.cartUrl + '.js', {headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'});
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          if (Number.isSafeInteger(cart.item_count)) document.querySelectorAll('[data-mc-count]').forEach(count => { count.textContent = cart.item_count; });
        }
      } catch {
        if (!added) { toast.hidden = false; toast.querySelector('[data-mc-message]').textContent = messages.dataset.error; }
      } finally { button.disabled = false; button.textContent = original; form.dataset.busy = 'false'; form.removeAttribute('aria-busy'); }
    });
  }));
  const cartForm = document.querySelector('[data-mc-cart-form]');
  cartForm?.addEventListener('input', () => { cartForm.querySelector('[data-mc-unsaved]').hidden = false; });
})();
